// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"74052c41","203":"de6fca77","355":"97baeefc","358":"86e9084b","686":"253473f0","711":"04442776","787":"9e24b57a","847":"ecf7ab19","944":"43eff46d","994":"20a51e99"}[chunkId] + ".chunk.js";
};